import { evaluateAdvancedRules } from './advancedRuleEvaluator';
import { getPreviewAllowedFieldValues } from './configurationAdminUtils';

const normalized = value => String(value ?? '').trim().toLowerCase();
const pumpProperties = { quantity: 'qty', 'pump description': 'pumpDescription', 'motor hp': 'motorHP', 'pump type': 'type', gpm: 'gpm', vfd: 'vfd', xl: 'xl', ss: 'ss', ebv: 'ebv' };

// Legacy quote IDs belong to a different lookup table. Resolve labels, never
// assume those IDs are ConfigFieldValues IDs.
export function evaluateQuoteAdvancedRules(quote, data) {
  const station = data.stations.find(item => normalized(item.stationName) === normalized(quote.stationType.stationType));
  const rows = quote.pumpConfigurations.map((pump, index) => {
    const row = { key: String(index), inputs: {}, selections: {} };
    data.fields.forEach(field => {
      const property = pumpProperties[normalized(field.fieldName)];
      if (!property) return;
      const raw = pump[property];
      row.inputs[field.id] = raw;
      const matches = data.fieldValues.filter(value => value.configFieldId === field.id && normalized(value.optionValue) === normalized(raw));
      if (matches.length === 1) row.selections[field.id] = matches[0].id;
    });
    return row;
  });
  const result = evaluateAdvancedRules({ rules: data.rules, stationId: station?.id, rows,
    canSetValue: (row, fieldId, valueId) => {
      const field = data.fields.find(item => item.id === fieldId);
      return Boolean(pumpProperties[normalized(field?.fieldName)] && getPreviewAllowedFieldValues({
        field, fieldValues: data.fieldValues, valueRules: data.valueRules || [], stationId: station?.id, selections: row.selections,
      }).some(item => item.id === valueId && !item.isDisabled));
    },
  });
  const pumps = quote.pumpConfigurations.map(pump => ({ ...pump }));
  result.updates.forEach(update => {
    const field = data.fields.find(item => item.id === update.fieldId);
    const value = data.fieldValues.find(item => item.id === update.fieldValueId);
    pumps[Number(update.rowKey)][pumpProperties[normalized(field.fieldName)]] = value.optionValue;
  });
  return { ...result, quote: result.updates.length ? { ...quote, pumpConfigurations: pumps } : quote };
}
